import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from './i18n';
import { App } from './App';
/*
  The brand's typefaces (Brand Guidelines 2026, §04): Montserrat for Latin,
  Almarai for Arabic. Self-hosted; each file carries a unicode-range, so the
  browser downloads only the scripts a page actually shows.
*/
import '@fontsource-variable/montserrat/wght.css';
import '@fontsource/almarai/400.css';
import '@fontsource/almarai/700.css';
import '@fontsource/almarai/800.css';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);
